import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";

import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import statusServiceInstance from '../services/StatusService';

import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
))(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const Help = () => {
    const [expanded, setExpanded] = React.useState('panel1');
    const [backendVersion, setBackendVersion] = useState('');
    const [frontendVersion, setFrontEndVersion] = useState('');

    useEffect(() => {
        statusServiceInstance.getServerVersion()
        .then((response) => {
            setBackendVersion(response);
        })
        .catch((error) => {
            setBackendVersion("<li>Not able to read the version history of Vaani Backend</li");
        }
        );

        fetch('/frontend-githistory.txt')
            .then(response => response.text())
            .then(data => {
                setFrontEndVersion(data);
            })
            .catch((error) => {
                setFrontEndVersion("<li>Not able to read the version history of Vaani Frontend</li");
            });
    }, []);

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <>
            <div className='breadcrumb'>
                <ul>
                    <li><NavLink to={'/'}><HomeIcon/></NavLink></li>
                    <span><NavigateNextIcon /></span>
                    <li><span>Help</span></li>
                </ul>                    
            </div>
            <h2 style={{display: 'flex', justifyContent: 'flex-start', margin: '15px 0 0 15px', }}>Help</h2>
            <div style={{padding: '15px'}}>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <Typography>Ediiting Subtitles</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <ol>
                            <h3> Ediiting English Subtitles</h3>
                            <img src="/help_EditingView.png" alt="Editing Subtitles" />
                            <h4>Subtitle Editing Pane and Top Bar:</h4>
                            <p>
                            <li>Home Button: Takes you the root of the directory</li>
                            <li>Folder Name: Clicking on this will take you the directory where this video is</li>
                            <li>Select the language you want to edit, this needs to match the language that you have
                                selected in the root directory. The root directory language selection is shown at the top of 
                                the "Video Pane". If the editing language does not match the root directory language, the
                                changes will not be saved.
                            </li>
                            <li>Exporting the subtitles - You can export the subtitles in SRT, VTT, and TXT formats. Once you 
                                select the format, click on the "Export" button to download the subtitles.
                            </li>
                            <li>Importing the subtitles - You can import the subtitles in SRT, VTT format. Click on the Import Button 
                                and select the file you want to import.
                            </li>
                            <li>Undo - You can undo edits made by clicking on Undo button or by using the key combination of 
                                "Ctrl + Z".
                            </li>
                            <li> Subtitles are saved automatically every 30 seconds, if the edit language selected in the first screen 
                                and this matches. If the language does not match, the changes will not be saved.
                                To manually save the changes, click on the "Save" button.
                            </li>
                            <li> You can do 4 operations on each subtitles 
                                <ul>
                                    <li>Comment - You can add a comment to every subtitle </li>
                                    <li>Bookmart - You can bookmark every subtitle </li>
                                    <li>Merge - You can merge the bottom subtitle with the current one with the merge button</li>
                                    <li>Delete - You can delete a subtitle</li>
                                </ul>
                            </li>
                            <li> Start and end times: You can edit the start the end times, in two ways
                                <ul>
                                    <li> Edit the start and end times by typing the numbers</li>
                                    <li> Dragging the subtitle box in the "Timeline Pane"</li>
                                    <li> CPS \ CPL - Yellow when either CPS = 24 or CPL = 45</li>
                                    <li> CPS \ CPL - Orange when either CPS = 28 or CPL = 55</li>
                                </ul>
                            </li>
                            <li> Subtitle Box: 
                                <ul>
                                    <li>Auto-Scroll: This will automatically scroll the video to the next subtitle. when the video is playing</li>
                                    <li>Edit the subtitles by clicking on the box and start typing</li>
                                    <li>Navigate to the next box by using the UP and DOWN Arrow keys</li>
                                    <li>To split the subtitle, place the cursor where you want the split, and press SHIFT+ENTER (Windows) or SHIFT + RETURN (MAC)</li>
                                </ul>
                            </li>
                            </p>
                            <h4>Timeline Pane:</h4>
                                <ul>
                                    <li>Clicking on the timeline will move the video and hence the Subtitle edit view to that time of the video</li>
                                    <li>Zoom In and Zoom Out: You can zoom in and out of the timeline by using the slider</li>
                                    <li>Dragging the subtitle box in the timeline will change the start and end times of the subtitle</li>
                                    <li>A new subtitle box can be created in the timeline view by holding the mouse dragging it based on the duration of the subtitle that is desired</li>
                                </ul>
                            
                            <h4>Video Pane:</h4>
                                <ul>
                                    <li>Play and Pause the video : Use Tab to play and pause the video or the Play button on the video</li>
                                </ul>
                            </ol>
                            <ol>
                                <h3> Editing Language Subtitles</h3>
                                <img src="/help_EditingLangSubtitles.png" alt="Editing Subtitles" />
                                <li> Start and end times: You can edit the start the end times same way as English, but edit the right column as 
                                    indicated in the image. 
                                </li>
                                <li> You can edit the subtitles same way as English, but edit the right column as indicated in the image.
                                </li> 
                            </ol>
                    </Typography>
                </AccordionDetails>
                
            </Accordion>
            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <Typography>Starting Translations</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <ol>
                            <h3>Speech to SRT - Upload video to get SRT file</h3>
                            <img src="/help_Upload-Video.png" alt="Upload a new Video" style={{ width: '250px', height: 'auto' }}/>
                            <li>
                                When you click on the "New Video", you see the image as above
                            </li>
                            <li>
                                Enter a video name 
                            </li>
                            <li>
                                Enter the Google Drive link OR Youtube Link OR Upload a local video less than 900MB
                            </li>
                            <li>
                                By default, the translation will be degenerated in English, to add any other language, please 
                                select from the Languages menu
                            </li>
                            <li>
                                The Developer Tools are used for testing or during development to fine tune the defaults, typically normal 
                                sevak will not need to use this, but if you are interested, please see below
                                <ul>
                                    <li>Skip the translation - this will not call the AI model but generate an empty SRT file. Use this 
                                        if you are importing SRT file from other tool such as Sonix. 
                                    </li>
                                    <li>Select which model you want to use</li>
                                    <li>Select if you want to see more logging in Vaani server logs, for this video upload</li>
                                    <li>Video Was Compressed: If you have compressed it prior and do not want server to compress the video </li>
                                    <li>Bit Rate & CRF Value: Adjust the level of compression - this defines the quality of the video that you see while 
                                        editing the subtitles. This currently has been tuned to allow all sevaks to work on the video without 
                                        a lot of buffering.
                                    </li>
                                </ul>
                            </li>
                            <li>If you are not happy with the video name you can edit the name by the yellow edit icon </li>
                        </ol>
                        <ol>
                            <h3>Text to SRT - Use English SRT to get other SRT files</h3>
                            <img src="/help_T2TT.png" alt="Text to Text" style={{ width: '500px', height: 'auto' }}/>
                            <li>Click on the Green Gear icon to bring up the T2TT Dialog</li>
                            <li>Select the a single source langauge</li>
                            <li>You can select as many target languages that you want</li>
                            <li>Click submit to kick off the translation, you will get a confirmation screen that Languages has been Updated
                                If the language is still being processed, you will not see it in the dropdown of Subtitle Edit View. 
                            </li>
                        </ol>
                        <ol>
                            <h3>Adding more languages</h3>
                            <img src="/help_T2TT.png" alt="Text to Text" style={{ width: '500px', height: 'auto' }}/>
                            <li>Click on the Green Gear icon to bring up the T2TT Dialog</li>
                            <li>If you adding Hindi, select Gujarati as the source language</li>
                            <li>If you adding Spanish, French, Russian etc, select English as the source language</li>
                            <li>You can select as many target languages that you want</li>
                            <li>Click submit to kick off the translation, you will get a confirmation screen that Languages has been Updated
                                If the language is still being processed, you will <b>NOT</b> see it in the dropdown of Subtitle Edit View. 
                            </li>
                        </ol>
                        <ol>
                            <h3> Regenerating Subtitles</h3>
                            <li> Click on the regenerate button to regenerate the subttiles. 
                                You would want to do that when the Translation Server failed to create the subtiles but you are happy with the video 
                                This WILL NOT regenerate the video, so do not use this if the video needs to be regenerated </li>
                        </ol>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                    <Typography>Users Section</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <ol>
                            <li>See all Users we currently have in our system.</li>
                            <li>Editing user features will come in the future.</li>
                        </ol>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
            <AccordionSummary expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                    <Typography>About Section</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <li>
                            <strong>Frontend Update:</strong> <br></br>
                            <ol>
                                <span dangerouslySetInnerHTML={{ __html: frontendVersion }} />
                            </ol>
                        </li>
                        <li>
                            <strong>Backend Update:</strong> <br></br>
                            <ol>
                            <span dangerouslySetInnerHTML={{ __html: backendVersion }} />
                            </ol>
                        </li>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            </div>
        </>
    );
};

export default Help;
